<template>
    <div class="ms-style2" v-if="isShow">
        <div class="two-top" @click="toLink(imgMap1)">
            <img :src="imgMap1.adImgUrl" v-if="imgMap1&&imgMap1.id" class="mst-img">
        </div>
        <div class="two-btm" @click="toLink(imgMap2)">
            <img :src="imgMap2.adImgUrl" v-if="imgMap2&&imgMap2.id" class="mst-img">
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                imgMap1: {},
                imgMap2: {},
                isShow:false
            };
        },
        props: {
            imgMap: Object
        },
        async created() {
            this.deptId = getDeptId()
            if (this.imgMap.one) {
                this.imgMap1 = this.imgMap.one
                this.isShow=true
            }
            if (this.imgMap.two) {
                this.imgMap2 = this.imgMap.two
                this.isShow=true
            }
        },

        methods: {
            toLink(item) {
                if (item.adLink) {
                    this.$router.push(item.adLink)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .ms-style2 {
        margin-bottom: 15px;
    }
    .two-top {
        width: 100%;
        margin-bottom: 5px;
    }

    .two-btm {
        width: 100%;
    }

    .mst-img {
        width: 100%;
    }
</style>
